// extracted by mini-css-extract-plugin
export var content = "features-module--content--kDySd";
export var featuresContainer = "features-module--featuresContainer--qBM--";
export var featureContainer = "features-module--featureContainer--Xban6";
export var copyColumn = "features-module--copyColumn--dR-Pr";
export var copyContainer = "features-module--copyContainer--hFC4m";
export var secondaryText = "features-module--secondaryText--Zz8nM";
export var primaryText = "features-module--primaryText--5HA-W";
export var imageColumn = "features-module--imageColumn--netKd";
export var reverse = "features-module--reverse--CIkdD";